import * as React from 'react'
import Short from '../../assets/short.svg'
import Med1 from '../../assets/med1.svg'
import Med2 from '../../assets/med2.svg'
import Long1 from '../../assets/long1.svg'
import Long2 from '../../assets/long2.svg'
import Long3 from '../../assets/long3.svg'

const waveformData = [
  { Component: Short, width: 562, height: 160 },
  { Component: Med1, width: 480, height: 160 },
  { Component: Med2, width: 520, height: 160 },
  { Component: Long1, width: 600, height: 160 },
  { Component: Long2, width: 540, height: 160 },
  { Component: Long3, width: 580, height: 160 }
]

export const Waveform = ({ progress, waveformIndex, maskId }: {
  progress: number
  waveformIndex: number
  maskId: string
}) => {
  const { Component: MaskedWaveform, width, height } = waveformData[waveformIndex] || waveformData[2]
  const svgRef = React.useRef<SVGSVGElement | null>(null)
  const pathRef = React.useRef<SVGGElement | null>(null)
  const [displayedWidth, setDisplayedWidth] = React.useState(width)

  React.useLayoutEffect(() => {
    if (pathRef.current) {
      const bbox = pathRef.current.getBBox()
      setDisplayedWidth(bbox.width)
    }
  }, [progress, waveformIndex])

  const maskWidth = ((displayedWidth) * progress) / 100

  return (
    <svg
      ref={svgRef}
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height="auto"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id={maskId}>
          <rect x={0} y={0} width={maskWidth} height={height} fill="#fff" />
        </mask>
      </defs>

      <g ref={pathRef}>
        <MaskedWaveform />
      </g>

      <g mask={`url(#${maskId})`} style={{ '--fill-color': '#fff' } as React.CSSProperties}>
        <MaskedWaveform />
      </g>
    </svg>
  )
}
